import React from 'react';
import { useSelector } from "react-redux";
import TargetHandle from '../TargetHandle';
import SourceHandle from '../SourceHandle';
import Iconify from '../../common/iconify/Iconify';
import { useReactFlow } from '@xyflow/react';
import { Divider, Stack, Tooltip } from '@mui/material';
import { ICONIFY } from '../../../Constants/iconify';
import CommonNode from './CommonNode';
import OptionsNode from './OptionsNode';
import NodeWrapper from './NodeWrapper';

const fullSx = { width: '100%', height: '100%' }

function DropdownNode({ data, isConnectable }) {

  return (
    <NodeWrapper nodeId={data?.id}>
      <OptionsNode data={data} icon={ICONIFY.DROPDOWN} />
    </NodeWrapper>
  );
};

export default DropdownNode